import type { RootState } from '../../../store';
import { qalTrackEvent } from '../trackEvent';

export const getLiabilityLimit = (state: RootState) => {
  const { liabilityLimit } = state.coverDetails;

  qalTrackEvent(
    {
      event: 'submit',
      eventAction: 'select liability limit',
      eventLabel: `${liabilityLimit}`,
    },
    state
  );
};
